(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sohni-rail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sp-rack')) {
  customElements.define('sp-rack', class extends HTMLElement {
    connectedCallback() {
      const t = this.track = this.querySelector('.r-track');
      this.items = [...t.children];
      if (!this.items.length) return;
      this.nameEl = this.querySelector('[data-name]');
      this.idle = this.nameEl.textContent;
      this.touch = matchMedia('(hover: none)').matches;
      this.on = null;
      this.last = t.scrollLeft;
      const itemOf = (el) => this.items.find((li) => li.contains(el));

      // Computer: hover/focus turns the garment forward
      t.addEventListener('mouseover', (e) => { if (!this.touch) this.set(itemOf(e.target)); });
      t.addEventListener('mouseleave', () => { if (!this.touch) this.set(null); });
      // Keyboard focus only; a tap also focuses the link and must not count as "already centred"
      t.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.set(itemOf(e.target)); });
      t.addEventListener('scroll', () => this.scrolled(), { passive: true });

      // Phone: tapping a side garment brings it to centre; tapping the centre one opens it
      t.addEventListener('click', (e) => {
        const li = itemOf(e.target);
        if (this.dragged) return e.preventDefault();
        if (this.touch && li && li !== this.on) { e.preventDefault(); this.center(li); }
      });

      // Mouse drag to slide the rack
      t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button) return;
        const x0 = e.clientX, s0 = t.scrollLeft;
        this.dragged = false;
        const move = (ev) => {
          if (Math.abs(ev.clientX - x0) > 5) this.dragged = true;
          if (this.dragged) t.scrollLeft = s0 - (ev.clientX - x0);
        };
        const up = () => {
          removeEventListener('pointermove', move);
          removeEventListener('pointerup', up);
          setTimeout(() => { this.dragged = false; });
        };
        addEventListener('pointermove', move);
        addEventListener('pointerup', up);
      });

      this.onEditor = (e) => { const li = itemOf(e.target); if (li) { this.center(li); this.set(li); } };
      document.addEventListener('shopify:block:select', this.onEditor);
      if (this.touch) this.pickCentre();
    }

    disconnectedCallback() {
      clearTimeout(this.stop);
      document.removeEventListener('shopify:block:select', this.onEditor);
    }

    set(li) {
      if (li === this.on) return;
      this.on?.classList.remove('on');
      this.on = li || null;
      li?.classList.add('on');
      this.nameEl.textContent = li ? li.dataset.title : this.idle;
    }

    center(li) {
      const t = this.track;
      t.scrollTo({ left: li.offsetLeft - (t.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
    }

    pickCentre() {
      const t = this.track, [a, b] = this.items;
      const step = b ? b.offsetLeft - a.offsetLeft : 1;
      const i = Math.round((t.scrollLeft + t.clientWidth / 2 - a.offsetLeft - a.offsetWidth / 2) / step);
      this.set(this.items[Math.max(0, Math.min(this.items.length - 1, i))]);
    }

    // One CSS variable write per frame while sliding; CSS handles the swing and settle
    scrolled() {
      if (this.raf) return;
      this.raf = requestAnimationFrame((now) => {
        this.raf = 0;
        const x = this.track.scrollLeft, dt = Math.max(now - (this.lt || now - 16), 8);
        const tilt = Math.max(-9, Math.min(9, ((this.last - x) / dt) * 5));
        this.last = x;
        this.lt = now;
        this.track.style.setProperty('--tilt', tilt.toFixed(2) + 'deg');
        clearTimeout(this.stop);
        this.stop = setTimeout(() => { this.track.style.setProperty('--tilt', '0deg'); this.lt = 0; }, 90);
        if (this.touch) this.pickCentre();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
